/* eslint-disable no-param-reassign */
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // CHOOSEN DATA
    rooms: [],
    transport: {},
    term: {},
    configuration_price: 0,
    configuration_old_price: 0,
    configuration_price_description: [],

    // AVAILABLES
    available_roomtypes: [],
    available_transports: [],
    available_terms: [],

    // RUNTIME
    changed_by_records: {
      transport: false,
      rooms_typology: false,
      terms: false,
      rooms: false,
      rooms_availability: false,
    },

    last_operation: {
      last_property: "",
      last_value: null,
    },
    available_terms_limit: 3,
    available_terms_next: false,

    configuration_changed: false,

    filter_terms_month: {},
    filter_terms_nights: {},

    default_kid_age: { value: 0, legend: "0-2 roky", infant: true },

    store_set_up: false,

    defaultFilters: {},

    filters: {},

    hotelList: {
      order: {
        id: 1,
        name: "cheap",
      },
      hotels: [],
      country_total: null,
    },

    resortList: {
      order: {
        id: 3,
        name: "recommanded",
      },
      resorts: [],
      filters: {
        resorts_downhills: false,
        highest_ski_point: false,
        distance_from_ch: false,
      },
      resort_total: null,
      country_total: null,
    },

    pagination: {
      records_per_page: 4,
      records_total: 120,
      maximum_pages_count: 5,
      page: 1,
    },
  },

  getters: {
    filters(state) {
      return state.filters;
    },

    hotels(state) {
      return state.hotelList.hotels || [];
    },

    hotelList(state) {
      return (
        state.hotelList || {
          sort: "asc",
          order: "cheap",
          hotels: [],
        }
      );
    },

    hotelCountryTotal(state) {
      return state.hotelList.country_total;
    },

    hotelOrder(state) {
      return state.hotelList.order;
    },

    pagination(state) {
      return state.pagination;
    },

    resortList(state) {
      return (
        state.resortList || {
          sort: "asc",
          order: {
            id: 3,
            name: "recommanded",
          },
        }
      );
    },

    resorts(state) {
      return state.resortList.resorts || [];
    },

    resortOrder(state) {
      return state.resortList.order;
    },

    resortFilters(state) {
      return state.resortList.filters;
    },

    resortCountyTotal(state) {
      return state.resortList.country_total;
    },

    resortTotal(state) {
      return state.resortList.resort_total;
    },
  },

  mutations: {
    setupStore(state, payload) {
      // CHOOSEN DATA
      if (
        payload.hasOwnProperty("rooms") &&
        Array.isArray(payload.rooms) &&
        payload.rooms.length > 0
      ) {
        state.rooms = JSON.parse(JSON.stringify(payload.rooms));
      } else {
        state.rooms = false;
      }

      if (payload.hasOwnProperty("transport")) {
        state.transport = JSON.parse(JSON.stringify(payload.transport));
      } else {
        state.transport = false;
      }

      if (payload.hasOwnProperty("term")) {
        state.term = JSON.parse(JSON.stringify(payload.term));
      } else {
        state.term = false;
      }
      state.configuration_price = payload.configuration_price;
      state.configuration_old_price = payload.configuration_old_price;
      state.configuration_price_description =
        payload.configuration_price_description;

      // AVAILABLES
      if (payload.hasOwnProperty("available_roomtypes")) {
        state.available_roomtypes = JSON.parse(
          JSON.stringify(payload.available_roomtypes)
        );
      } else {
        state.available_roomtypes = false;
      }

      state.available_transports = JSON.parse(
        JSON.stringify(payload.available_transports)
      );

      if (payload.hasOwnProperty("available_terms")) {
        state.available_terms = JSON.parse(
          JSON.stringify(payload.available_terms)
        );
      } else {
        state.available_terms = false;
      }

      state.available_terms_next = payload.available_terms_next;
      state.available_terms_limit = payload.available_terms_limit;

      state.changed_by_records.transport = false;
      state.changed_by_records.rooms_typology = false;
      state.changed_by_records.terms = false;
      state.changed_by_records.terms = false;

      setTimeout(() => {
        state.store_set_up = true;
      }, 100);
    },

    setDefaultKidsAge(state, payload) {
      state.default_kid_age = payload;
    },

    rollbackOperation(state) {
      const property = state.last_operation.last_property;
      const value = JSON.parse(JSON.stringify(state.last_operation.last_value));

      if (property.search("state") !== -1) {
        let stateProperty = eval(property);
        stateProperty = value;
      } else {
        state[property] = value;
      }
    },

    addEmptyRoom(state) {
      if (state.rooms === false) {
        state.rooms = [];
      }
      state.rooms.push({
        adults: 1,
        kids: [],
        type: { room_id: "", room_label: "" },
      });
    },
    removeRoom(state, index) {
      state.rooms.splice(index, 1);
    },
    addNewKids(state, payload) {
      state.last_operation.last_property = "rooms";
      state.last_operation.last_value = JSON.parse(JSON.stringify(state.rooms));

      for (let i = 0; i < payload.new_kids; i++) {
        state.rooms[payload.index].kids.push(state.default_kid_age);
      }
    },
    removeKids(state, payload) {
      state.last_operation.last_property = "rooms";
      state.last_operation.last_value = JSON.parse(JSON.stringify(state.rooms));

      let currentKids = state.rooms[payload.index].kids;
      currentKids = currentKids.slice(0, payload.remove_kids);
      state.rooms[payload.index].kids = currentKids;
    },
    chooseTransport(state, transport) {
      state.last_operation.last_property = "transport";
      state.last_operation.last_value = state.transport;
      state.transport = transport;
    },
    changeKidAge(state, payload) {
      state.rooms[payload.room_index].kids[payload.kid_index] = payload.age;
    },
    changeAdultCount(state, payload) {
      state.last_operation.last_property = "rooms";
      state.last_operation.last_value = JSON.parse(JSON.stringify(state.rooms));
      state.rooms[payload.room_index].adults = payload.adults;
    },
    changeTerm(state, payload) {
      state.last_operation.last_property = "term";
      state.last_operation.last_value = state.term;
      state.term = payload;
    },
    setRoomtype(state, payload) {
      state.last_operation.last_property = "rooms";
      state.last_operation.last_value = JSON.parse(JSON.stringify(state.rooms));
      state.rooms[payload.room_index].type = payload.room_type;
    },
    setRoomAvailability(state, payload) {
      state.last_operation.last_property = `state.rooms[${payload.room_index}].adults`;
      state.last_operation.last_value = state.rooms[payload.room_index].adults;
      state.rooms[payload.room_index].adults = payload.room_adults;
    },
    changeAvailableTransports(state, payload) {
      state.available_transports = payload;
    },
    changeAvailableRoomtypes(state, payload) {
      state.available_roomtypes = payload;
    },
    changeAvailableTerms(state, payload) {
      state.available_terms = payload;
    },

    setChangedByRecords(state, payload) {
      state.changed_by_records[payload] = true;
    },
    resetChangedByRecords(state, payload) {
      state.changed_by_records[payload] = false;
    },

    setConfigurationPrice(state, payload) {
      state.configuration_price = payload.configuration_price;
      state.configuration_old_price = payload.configuration_old_price;
      state.configuration_price_description =
        payload.configuration_price_description;
    },

    extendTerms(state) {
      state.available_terms_limit += 3;
    },

    setAvailableTermsNext(state, payload) {
      state.available_terms_next = payload;
    },

    setFilterMonth(state, payload) {
      state.filter_terms_month = payload;
    },
    setFilterNights(state, payload) {
      state.filter_terms_nights = payload;
    },
    setTermFomo(state, payload) {
      state.term.term_fomo = payload;
    },

    /** filters, hotels and resort */
    setDefaultFilters(state, filters) {
      state.defaultFilters = JSON.parse(JSON.stringify(filters));
      state.filters = JSON.parse(JSON.stringify(filters));
    },

    setFilters(state, filters) {
      state.filters = filters;
    },

    setFiltersCount(state, filters) {
      Object.keys(filters).forEach((key) => {
        let obj = filters[key];

        if (obj !== null) {
          if (obj.hasOwnProperty("values")) {
            state.filters[key].values = obj.values;
          } else if (obj.hasOwnProperty("min") && obj.hasOwnProperty("max")) {
            state.filters[key].min = obj.min;
            state.filters[key].max = obj.max;
          }
        }
      });
    },

    updateFilter(state, { filterName, filterValue }) {
      const newFilters = { ...state.filters };

      if (newFilters[filterName]) {
        newFilters[filterName].value = filterValue;
        state.filters = newFilters;
      }
    },

    resetFilters(state) {
      state.filters = JSON.parse(JSON.stringify(state.defaultFilters));
    },

    setHotels(state, hotels) {
      state.hotelList.hotels = hotels;
    },

    setHotelFavorite(state, payload) {
      state.hotelList.hotels.forEach((local_hotel) => {
        if (local_hotel.id === payload.hotel.id) {
          local_hotel.is_favorite = payload.favorite;
        }
      });
    },
    setHotelOrder(state, orderIndex) {
      switch (orderIndex) {
        case 1:
          state.hotelList.order = {
            id: 1,
            name: "cheap",
          };
          break;

        case 2:
          state.hotelList.order = {
            id: 2,
            name: "expensive",
          };
          break;

        case 0:

        // eslint-disable-next-line no-fallthrough
        case 3:
          state.hotelList.order = {
            id: 3,
            name: "recommended",
          };
          break;

        default:
          break;
      }
    },

    setHotelCountryTotal(state, number) {
      state.hotelList.country_total = number;
    },

    setResortList(state, data) {
      state.resortList.resorts = data;
    },

    setResorts(state, resorts) {
      state.resortList.resorts = resorts;
    },

    setResortOrder(state, orderIndex) {
      switch (orderIndex) {
        case 1:
          state.resortList.order = {
            id: 1,
            name: "cheap",
          };
          break;

        case 2:
          state.resortList.order = {
            id: 2,
            name: "expensive",
          };
          break;

        case 0:
          state.resortList.order = {
            id: 3,
            name: "recommended",
          };
          break;

        default:
          break;
      }
    },

    updateResortFilter(state, { filterName, filterValue }) {
      state.resortList.filters[filterName] = filterValue;
    },

    presetResortsFilter(state, resorts_filter_settings) {
      let newSettings = {};
      Object.keys(resorts_filter_settings).map((val, key) => {
        let obj = resorts_filter_settings[val];
        newSettings[val] = obj.value;
      });

      state.resortList.filters = newSettings;
    },

    setPage(state, page) {
      state.pagination.page = page;
    },

    setPagination(state, data) {
      state.pagination = data;
    },

    setResortCountyTotal(state, number) {
      state.resortList.country_total = number;
    },

    setResortTotal(state, number) {
      state.resortList.resort_total = number;
    },
  },
});
